import {trackEventFromState} from '@eb/site-analytics';

import {GA_HOME_FEED_CATEGORY} from '../../constants/analytics';

export const SET_LOADING = 'SET_LOADING';
export const SET_CITY_BROWSE_LOADING = 'SET_CITY_BROWSE_LOADING';
export const SET_PROFILES_LOADING = 'SET_PROFILES_LOADING';
export const SET_ORGANIZER_ARTICLES_LOADING = 'SET_ORGANIZER_ARTICLES_LOADING';

export const setLoading = (isLoading) => ({type: SET_LOADING, payload: isLoading});

export const setCityBrowseLoading = (isLoading) => ({type: SET_CITY_BROWSE_LOADING, payload: isLoading});

export const setProfilesLoading = (isLoading) => ({type: SET_PROFILES_LOADING, payload: isLoading});

export const setOrganizerArticlesLoading = (isLoading) => ({type: SET_ORGANIZER_ARTICLES_LOADING, payload: isLoading});

// This doesn't seems to be working
export const trackFeedEvent = (trackingProps) => (
    (dispatch, getState) => {
        trackEventFromState(getState(), {
            category: GA_HOME_FEED_CATEGORY,
            ...trackingProps,
        });
    }
);
